<template>
	<main class="ly_col-4 ly_mw-40 ml_center">
		<div class="ly_col-4 ly_a_center">
			<div class="ly_col-16 ly_a_center">
				<img src="@/assets/img/common/complete.png" alt="구독해지 완료 아이콘" loading="lazy" />
				<div class="icon_title">
					<p>{{ THANK_YOU_MESSAGE }}</p>
				</div>
			</div>
			<div class="ly_col-16">
				<div class="ml_memo">
					<p class="ml_memo_title">[안드로이드]</p>
					<ul class="ml_memo_list">
						<li>
							* Google Play 스토어 자동 결제 해지는 [Google<br v-if="!displayStore.isDesktop" />Play 스토어 > 프로필 >
							결제 및 정기 결제]에서<br v-if="!displayStore.isDesktop" />
							진행해주셔야 합니다.
						</li>
					</ul>
				</div>
				<div class="ml_memo">
					<p class="ml_memo_title">[애플]</p>
					<ul class="ml_memo_list ly_col-16">
						<li>
							* 애플 앱스토어 자동 결제 해지는 [앱스토어 ><br v-if="!displayStore.isDesktop" />
							계정 > 구독]에서 진행해주셔야 합니다.
						</li>
						<li>* 자동 결제를 해지하더라도 구독 만료일까지<br v-if="!displayStore.isDesktop" />사용 가능합니다.</li>
					</ul>
				</div>
			</div>
		</div>
		<div class="c_fieldArea">
			<button class="c_button radius-x-small primary-fill save" @click="onClickHome">홈으로 가기</button>
		</div>
	</main>
</template>

<script setup lang="ts">
// core
import { useRouter } from 'vue-router';

import { THANK_YOU_MESSAGE } from '@/constants/title';
// store
import { useDisplayStore } from '@/stores/display';
import { usePaymentStore } from '@/stores/payment';

const displayStore = useDisplayStore();
const router = useRouter();
const paymentStore = usePaymentStore();

const onClickHome = () => {
	paymentStore.resetPayment();
	router.replace('/home');
};
</script>

<style lang="scss" scoped>
.ml_center {
	img {
		width: 12rem;
	}
	.ly_col-4 .icon_title {
		font-weight: var(--font-w-semi-bold);
		font-size: var(--space-large);
		line-height: 2.387rem;
	}
	.c_fieldArea {
		button {
			font-weight: var(--font-w-medium);
			font-size: var(--font-s-regular);
			line-height: 2.1rem;
			height: 4.8rem;
		}
	}
}

.ml_memo {
	color: var(--color-base-light);
	font-size: var(--font-s-regular);
	font-weight: var(--font-w-light);
	line-height: 2.3rem;
}
</style>
